import Vue from 'vue'
import Vuex from 'vuex'
import player from '@/store/modules/player'//播放器
import service_provider from '@/store/modules/service_provider.js'//服务商
import logoFull from "@/assets/img/head/headLogo.png";
import customerServiceQrCodeFull from '@/assets/img/erweima/customer_service.png'
import aboutUsBannerFull from "@/assets/img/about_us/top.png";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    info: null,// 用户基本信息
    otherParkInfo: null,//其他园区信息
    parkInfo:null,//当前选中园区
    isRouterAlive: true,
    loginStatus: false,
    company: '', //当前选中企业名称
    company_address:'',  //当前选中企业的地址
    employee:'',//当前员工信息对象
    companyObj:null,//当前选中企业对象
    webConfig: {
			aboutUs: '',
			aboutUsBanner: null,
			aboutUsBannerFull: aboutUsBannerFull,
			contactAddress: '广州市南沙区环市大道南27号自编1栋',
			copyright: '广东省华南技术转移中心有限公司',
			customerServiceQrCode: '',
			customerServiceQrCodeFull:customerServiceQrCodeFull,
			description: '“孵化育成平台”是华南技术转移中心着力打造的科技孵化园区赋能平台，针对目前园区载体存在的“强地产，弱产业”、“重政策，轻运营”的问题，以【5+赋能】理念，即“互联网+ ”、“运营服务体系+”、“共享产业招商+”、“公共技术平台+”、“产业资源+”，以共享模式，聚合优质的产业及服务资源，打造以赋能为核心的共享产业服务O2O生态圈，为园区向“地产+”平台生态圈的转型发展提供全方位产业赋能服务。',
			favicon: '',
			faviconFull: '',
			icp: '粤ICP备18077262号',
			keywords: 'TOPS新家园,孵化',
			logo: '',
			logoFull: logoFull,
			parkId: '',
			serviceTime: null,
			tel: '020-39075666',
			title: '园区无忧-华转孵化器赋能平台'
		} //网页配置信息
  },
  mutations: {
    //保存跳转参数
    setRouteObj(state, obj) {
      state.routeObj = obj
    },
    setInfo(state, data) {
      state.info = data;
    },
    setOtherParkInfo(state, data) {
      state.otherParkInfo = data;
    },
    setIsRouterAlive(state, data) {
      state.isRouterAlive = data;
    },
    setLoginStatus(state, data) {
      state.loginStatus = data;
    },
    setCompany(state, data) {
      state.company = data
    },
    setCompanyAddress(state, data) {
      state.company_address = data
    },
    setPark(state, data) {
      state.parkInfo = data
    },
    setEmployee(state, data) {
      state.employee = data
    },
    setCompanyObj(state, data) {
      state.companyObj = data
    },
    setWebConfig(state, data) {
      state.webConfig = data
    },
  },
  actions: {
    setInfo(context, data) {
      context.commit("setInfo", data)
    },
    setOtherParkInfo(context, data) {
      context.commit("setOtherParkInfo", data)
    },
    setIsRouterAlive(context, data) {
      context.commit("setIsRouterAlive", data)
    },
    setLoginStatus(context, data) {
      context.commit("setLoginStatus", data)
    },
    setCompany(context, data) {
      context.commit("setCompany", data)
    },
    setCompanyAddress(context, data) {
      context.commit("setCompanyAddress", data)
    },
    setPark(context, data) {
      context.commit("setPark", data)
    },
    setEmployee(context, data) {
      context.commit("setEmployee", data)
    },
    setCompanyObj(context, data) {
      context.commit("setCompanyObj", data)
    },
    setWebConfig(context, data){
      context.commit("setWebConfig", data)
    }
  },
  modules:{
    player,
    service_provider
  }
})
